import {FontAwesomeIcon as Icon} from "@fortawesome/react-fontawesome"
import {Panel} from "components/Panel"
import React from "react"
import UpdateNotificationSettings from "./Notifications/UpdateNotificationSettings"
import UpdateContactInformation from "./Profile/UpdateContactInformation"
import UpdatePassword from "./Profile/UpdatePassword"
import UpdateProfilePhoto from "./Profile/UpdateProfilePhoto"
import Settings from "./Settings"
import UpdateBudget from "./Profile/UpdateBudget"
import Trans from '../../components/Trans'

class Profile extends React.Component {
  render() {
    return (
      <Settings>
        <div className="max-w-2xl lg:max-w-3xl xl:max-w-4xl lg:mx-auto h-full">
          <Panel overflowVisible={true}>
            <div className="flex flex-row px-4 py-2 font-semibold text-gray-600 items-center">
              <Icon icon="user"/>
              <div className="ml-1"><Trans>Profil</Trans></div>
            </div>
            <div className="p-4">
              <UpdateProfilePhoto/>

              <div className="border-t border-gray-300 my-4"/>

              <UpdateContactInformation/>

              <div className="border-t border-gray-300 my-4"/>

              <UpdatePassword/>

              <div className="border-t border-gray-300 my-4"/>

              <UpdateNotificationSettings/>

              <div className="border-t border-gray-300 my-4"/>

              <UpdateBudget/>
            </div>
          </Panel>
        </div>
      </Settings>
    )
  }
}

export default Profile
